import { handleErrorDialog, showAlertDialog, showProgressDialog } from '@juvare/common-web-ui/DialogHelper';
import { Box, Button } from '@mui/material';
import React from 'react';
export const exportToCsv = (exportCsv, fileName, t) => {
    function getExportedCsvFileName(title) {
        const name = title.toLowerCase().replace(/\s+/g, '_');
        const timestamp = new Date().toISOString().replace(/\..*$/, '').replace(/[-:]/g, '').replace(/T/, '_');
        return `${name}_export_${timestamp}.csv`;
    }
    showProgressDialog({
        title: t('csvExport.progressDialogTitle'),
        callback: (done) => {
            exportCsv()
                .then((dataUrl) => {
                showAlertDialog({
                    title: t('csvExport.alertDialogTitle'),
                    content: (React.createElement(Box, { p: 4, sx: { display: 'flex', justifyContent: 'center' }, "data-test": 'export-to-csv' },
                        React.createElement(Button, { variant: 'contained', color: 'primary', download: getExportedCsvFileName(fileName), href: dataUrl, "data-test": 'download-button' }, t('csvExport.downloadButtonText')))),
                });
            })
                .catch(handleErrorDialog)
                .finally(done);
        },
    });
};
